import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./styles/fonts"; // CR109: Load bundled fonts
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
